  <h2 translate>STATUS.REFRESHMENT_INDICATOR</h2>
  <div class="graph-container">
    <canvas class="chart-canvas" #chartCanvas></canvas>

    <ng-template [ngIf]="loadingData">
      <div class="graph-spinner-container">
        <ion-spinner color="dark"></ion-spinner>
      </div>
    </ng-template>

  </div>

  <p class="indicator-description" translate>STATUS.FACTOR_DESCRIPTION</p>
  <div class="indicator-grid">

    <div class="indicator-row">
      <div class="label-col"></div>
      <div class="indicator-col">
        <div translate>STATUS.WEEK</div>
      </div>
      <div class="indicator-col">
        <div translate>STATUS.PREVIOUS_WEEK</div>
      </div>
      <div class="indicator-col">
        <div translate>STATUS.MONTH</div>
      </div>
      <div class="indicator-col">
        <div translate>STATUS.YEAR</div>
      </div>
    </div>

    <div class="indicator-row">
      <div class="label-col">
        <div translate>STATUS.DETACHMENT</div>
      </div>
      <ng-template ngFor let-item [ngForOf]="detachmentAverages">
        <div class="indicator-col">
          <status-indicator [level]="item"></status-indicator>
        </div>
      </ng-template>
    </div>

    <div class="indicator-row">
      <div class="label-col">
        <div translate>STATUS.RELAXATION</div>
      </div>
      <ng-template ngFor let-item [ngForOf]="relaxationAverages">
        <div class="indicator-col">
          <status-indicator [level]="item"></status-indicator>
        </div>
      </ng-template>
    </div>

    <div class="indicator-row">
      <div class="label-col">
        <div translate>STATUS.EXPERIENCE</div>
      </div>
      <ng-template ngFor let-item [ngForOf]="experienceAverages">
        <div class="indicator-col">
          <status-indicator [level]="item"></status-indicator>
        </div>
      </ng-template>
    </div>

  </div>

